import { Link } from "react-router-dom";

// Original EM monogram logo with transparent background
const LOGO_URL = "/em-logo.png?v=1";

export const Logo = ({ size = "md", white = false, className = "" }) => {
  const dims =
    size === "lg"
      ? "h-28 md:h-32 w-40 md:w-48"
      : size === "sm"
        ? "h-14 w-20"
        : "h-20 md:h-24 w-28 md:w-32";

  return (
    <Link
      to="/"
      data-testid="evara-logo"
      className={`inline-flex items-center shrink-0 ${className}`}
      aria-label="EVARA Monaco — Accueil"
    >
      <div
        className={`${dims} bg-no-repeat bg-center bg-contain select-none transition-[filter] duration-300 ${white ? "[filter:brightness(0)_invert(1)]" : ""}`}
        style={{ backgroundImage: `url(${LOGO_URL})` }}
        role="img"
        aria-label="EVARA Monaco"
      />
    </Link>
  );
};
